import { Component, ElementRef, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { Location } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ErrorType } from 'src/app/enums/error-type.enum';

@Component({
  selector: 'fury-edit-copay-fee-text',
  templateUrl: './edit-copay-fee-text.component.html',
  styleUrls: ['./edit-copay-fee-text.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class EditCopayFeeTextComponent implements OnInit {

  copayFeeTextForm!: FormGroup;
  editorConfig = {
    allowedContent: false,
    toolbarGroups: [
      { name: 'clipboard', groups: ['clipboard', 'undo'] },
      { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
      { name: 'links' }, { name: 'insert' },
      { name: 'document', groups: ['mode', 'document', 'doctools'] },
      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
      { name: 'styles' },
      { name: 'colors' }
    ],
    forcePasteAsPlainText: true,
    image_previewText: ' '
  };
  constructor(
    private apiService: ApiService,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.formInit();
    this.getCopayFeeData();
  }
  formInit(){
    this.copayFeeTextForm = new FormGroup({
      copayFeeText: new FormControl('', [Validators.required]),
    })
  };

  getCopayFeeData(){
    this.apiService.get('admin/settings/copay-fee-text/get-copay-fee-text-settings').subscribe((res: any)=>{
      if(res?.body){
        this.copayFeeTextForm.patchValue({
          copayFeeText: res.body?.copayFeeText?.text
        });
      }
    })
  }
  saveCopayFee(){ 
    if(this.copayFeeTextForm.valid){
    this.apiService.post('admin/settings/copay-fee-text/save-copay-fee-text-settings', this.copayFeeTextForm.value).subscribe((res: any)=>{
      if(res?.body){
        this.apiService.alert(res?.body?.message, ErrorType.Success);
        this.location.back();
      }
    }, err =>{
      if(err){
        this.apiService.alert(err?.message, ErrorType.Error);
      }
    })
      
    } else {
      this.copayFeeTextForm.markAllAsTouched();
    }
  }


}
